import React, { useEffect } from "react"
import { NumberTagFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function LeadTimeDaysField() {

	const {
		withinDays,
		setWithinDaysInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().withinDays,
		"withinDays",
		object({
			withinDays: array()
				.required("Must provide a number of positive days")
				.test("min", "Must provide a number of positive days", () => !!withinDays.length && withinDays.every(e => +e >= 0))
		}))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setWithinDaysInfo(null, false)
		}
	}, [useCsv.value])


	return <NumberTagFieldSeeker
		label="Lead time days"
		placeholder="0 for today"
		onChange={setWithinDaysInfo}
		value={withinDays || []}
		error={error}
	/>
}